module.exports = __webpack_public_path__ + "img/u3881.dbd81ec0.svg";